export interface ProductData {
  Id: number;
  Sasi: string;
  CariAdi: string;
  AliciTeslimEdilen: string;
  Motor: string;
  Model: number;
  KategoriAdi: string;
  MarkaAdi: string;
  ModelAdi: string;
  RenkAdi: string;
  SaticiAdi?: string;
  SaticiTelefon: string;
  SaticiAdres?: string;
  Ulke?: number;
  SaticiIl?: number;
  SaticiIlAdi?: string;
  SaticiIlce?: number;
  SaticiIlceAdi?: string;
  AliciTelefon: string;
  AliciFaturaNo: string;
  AliciFaturaTarihi: string;
  AliciAdres?: string;
  AliciEPosta?: string;
  AliciBelgeNo?: string;
  AliciTeslimYeri?: string;
  AliciTeslimTarihi?: string;
  SonIslem?: number;
  IslemAdi?: string;
  SonEtkinlikTipi?: number;
  MotorMu: boolean;
  MontajBedeli: number;
  GarantiDurumu?: number;
  GarantiDurumuAciklamasi?: string;
  GarantiDevamEdiyorMu?: boolean;
  GarantiBitisTarihi?: string;
}

export interface SerialNumberResponse {
  data: ProductData[];
  total: number;
}

export interface PartGroup {
  Id: number;
  Ad: string;
}

export interface PartGroupsResponse {
  data: PartGroup[];
  total: number;
}

export interface IssueReason {
  Id: number;
  Ad: string;
  Oncelik?: number | null;
}

export interface IssueReasonsResponse {
  data: IssueReason[];
  total: number;
}

export enum WizardStep {
  SERIAL_CHECK = 0,
  PRODUCT_DETAIL = 1,
  ISSUE_DETAILS = 2,
  PART_SELECTION = 3,
  MEDIA_UPLOAD = 4,
}

// IssueReason enum kaldırıldı - artık dinamik veri kullanılıyor

/**
 * Talep tipi enum'u
 * Servis talebinin tipini belirtir
 */
export enum RequestType {
  BUYER = 1, // Alıcı talebi
  SELLER = 2, // Satıcı talebi
}

/**
 * Bakım tipi enum'u
 * Bakım girişi için servis tiplerini belirtir
 */
export enum MaintenanceType {
  FIRST_ASSEMBLY = 1, // İlk Montaj
  ODOMETER_CHANGE = 2, // Km Sayacı Değişim
  PERIODIC_MAINTENANCE = 3, // Periyodik Bakım
  GENERAL_MAINTENANCE = 4, // Genel Bakım
  ACCIDENT_REPAIR = 5, // Kaza Onarım
}

export interface MediaFile {
  id: string;
  file: File;
  preview: string;
  type: 'image' | 'video';
  uploading?: boolean;
  error?: string;
}

export interface YedekParcaData {
  Kod: string;
  Ad: string;
  Gorsel: string | null;
  GrupAdi: string;
  Stok: number;
  CariStokDurumu: boolean;
  ListeFiyati: number;
  BayiFiyati: number;
  IscilikBedeli: number;
  PromosyonluMu: boolean;
  AktifMi: boolean;
  Id: number;
}

export interface YedekParcaResponse {
  total: number;
  data: YedekParcaData[];
}

/**
 * İşlem tipi enum'u
 * Servis talebinin mevcut durumunu belirtir
 */
export enum ActionType {
  CREATED = 0,
  WAITING_FOR_APPROVAL = 1,
  APPROVED = 2,
  CANCELLED = 3
}

/**
 * Servis talebi verisi
 * Kupon: Ürün ID
 * No: Talep numarası
 * Tip: Talep tipi (enum TalepTipi değeri)
 * Km: Kilometre
 * ArizaNedeni: Arıza nedeni (enum IssueReason değeri)
 * ServisNotlari: Servis notları
 * Tarih: Talep tarihi
 * SonIslem: İşlem tipi (enum IslemTipi değeri)
 * Not: Yedek parçalar artık ayrı TalepYedekParcalari modeli ile yönetiliyor
 */
export interface ServiceRequestData {
  Kupon: number;
  No: string;
  Tip: RequestType;
  Km: number;
  ArizaNedeni: number;
  ServisNotlari: string;
  Tarih: string;
  SonIslem: ActionType;
}

/**
 * Servis talebi oluşturma yanıtı
 */
export interface ServiceRequestCreateResponse {
  success: boolean;
  data?: {
    Id: number;
  };
  error?: string;
  msg?: string;
}

/**
 * Talep yedek parçası verisi
 * TalepYedekParcalari modeli için
 */
export interface ServiceRequestSparePartData {
  Talep: number;
  YedekParca: number;
  Miktar: number;
  IscilikBedeli: number;
  Tracker?: string;
}

/**
 * Talep yedek parçası oluşturma yanıtı
 */
export interface ServiceRequestSparePartCreateResponse {
  success: boolean;
  data?: {
    Id: number;
  };
  error?: string;
  msg?: string;
}

export interface UsedWarrantyPart {
  Id: number;
  Kod: string;
  Ad: string;
}



